import styled from "@emotion/styled";
import { fontAngkor, fontFredoka } from "@product/scmp-sdk";

import { Container as SCMPYouTubeVideoPlayerContainer } from "scmp-app/components/scmp-youtube-video/scmp-youtube-video-player/styles";

export const Container = styled.div`
  max-inline-size: 972px;
  margin: auto;
`;

export const VideoContainer = styled.div`
  margin-block: 0;
  margin-inline: -20px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin: 0;
  }
  ${SCMPYouTubeVideoPlayerContainer} {
    margin-block-start: 0;
  }
`;

export const TextContainer = styled.div`
  margin-block-start: 20px;
  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }
`;

export const TopicLabel = styled.div`
  color: #ff7c1d;
  font-weight: 600;
  font-size: 13px;
  font-family: ${fontFredoka};
  line-height: 16px;
  letter-spacing: 0.65px;
  text-transform: uppercase;
  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.9px;
  }
`;

export const Headline = styled.div`
  margin-block: 8px 16px;
  margin-inline: 0;

  color: #1b4191;
  font-weight: 400;
  font-size: 24px;
  font-family: ${fontAngkor};
  line-height: 28px;
  letter-spacing: -0.72px;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block: 8px 32px;
    margin-inline: 0;

    font-size: 40px;
    line-height: 44px;
    letter-spacing: -1.2px;
  }
`;

export const BodyText = styled.div`
  padding-block-end: 32px;

  color: #333333;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontFredoka};
  font-style: normal;
  line-height: 20px;
  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block-end: 48px;
  }
`;
